import React from 'react'

const AdminFooter = () => {

    return (
        <footer className="footer">
            <div className="container-fluid d-flex justify-content-between">
                <span className="copyright">
                    Copyright © 2024 - Krishna Prints Solution. All Rights Reserved
                </span>
            </div>
        </footer>
    )
}

export default AdminFooter